import component from './confidential.vue'

export default component
